export const IS_SHIPPING_SCREEN_VALID = 'isShippingScreenValid';

export type ServiceCheckoutQueries = {
    [IS_SHIPPING_SCREEN_VALID]: undefined;
};

export type ServiceCheckoutQueriesResponseType = {
    [IS_SHIPPING_SCREEN_VALID]: boolean;
};
